import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { AppShell } from "@/components/AppShell";
import { RequireAuth } from "@/components/RequireAuth";
import { LoginPage } from "@/pages/Login";
import { OACallbackPage } from "@/pages/OACallback";
import { InitAdminPage } from "@/pages/InitAdmin";
import { AdminUsersPage } from "@/pages/AdminUsers";
import { LandResearchPage } from "@/pages/LandResearch";
import { LandResearchProgressPage } from "@/pages/LandResearchProgress";
import { LandDataPage } from "@/pages/LandData";
import { MemoryCenterPage } from "@/pages/MemoryCenter";
import { AuditLogPage } from "@/pages/AuditLog";

/** Old chat / report-preview links carry a conv id — land them on the data page for that run. */
function LegacyConvRedirect(): JSX.Element {
  const { convId } = useParams();
  return <Navigate to={convId ? `/land/${convId}` : "/land"} replace />;
}

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/oa-callback" element={<OACallbackPage />} />
        <Route path="/init-admin" element={<InitAdminPage />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/" element={<Navigate to="/land" replace />} />
          {/* 对话 / 工作流已整体移除；旧链接回落到地块数据。 */}
          <Route path="/c/:convId" element={<LegacyConvRedirect />} />
          <Route path="/workflows/*" element={<Navigate to="/land" replace />} />
          <Route path="/data-sources" element={<Navigate to="/land" replace />} />
          <Route path="/land" element={<LandResearchPage />} />
          {/* Legacy frontend-only management URLs now return to the primary workflow. */}
          <Route path="/land/rules" element={<Navigate to="/land" replace />} />
          <Route path="/land/rules/calibration" element={<Navigate to="/land" replace />} />
          <Route path="/land/compare" element={<Navigate to="/land" replace />} />
          <Route path="/land/:convId/preview" element={<LegacyConvRedirect />} />
          <Route path="/land/:convId/data" element={<LandDataPage />} />
          <Route path="/land/:convId" element={<LandResearchProgressPage />} />
          {/* admin-only management pages, hidden from regular nav */}
          <Route
            path="/admin/users"
            element={
              <RequireAuth role="admin">
                <AdminUsersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/memory"
            element={
              <RequireAuth role="admin">
                <MemoryCenterPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/audit"
            element={
              <RequireAuth role="admin">
                <AuditLogPage />
              </RequireAuth>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/land" replace />} />
      </Routes>
    </AuthProvider>
  );
}
